package pl.zar.tikthrow.ui.theme

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color

val ScreenBackground = Slate50

@Composable
fun TabScreenBackground(
    modifier: Modifier = Modifier,
    content: @Composable BoxScope.() -> Unit
) {
    Box(
        modifier = modifier
            .fillMaxSize()
            .background(ScreenBackground)
            .drawBehind {
                val w = size.width
                val h = size.height

                // Skip drawing while the node has no positive area. On Web/Skiko
                // the first/relayout frames can report a 0 or negative size;
                // drawing into that (or the unbounded line loop below) throws
                // "Width and height must be greater than or equal to zero".
                if (w <= 0f || h <= 0f) return@drawBehind

                // Subtle neutral grid — texture only, no color
                val gridColor = Color.White.copy(alpha = 0.02f)
                val step = 52f
                var x = 0f
                while (x <= w + step) {
                    drawLine(gridColor, Offset(x, 0f), Offset(x, h), strokeWidth = 0.5f)
                    x += step
                }
                var y = 0f
                while (y <= h + step) {
                    drawLine(gridColor, Offset(0f, y), Offset(w, y), strokeWidth = 0.5f)
                    y += step
                }
            },
        content = content
    )
}
